import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import OurBusiness from './pages/OurBusiness';
import OurCompliance from './pages/OurCompliance';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import { Toaster } from './components/ui/sonner';
import './App.css';

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background">
        <Routes>
          <Route path="/" element={
            <>
              <Navigation />
              <ScrollToTop />
              <Home />
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Navigation />
              <ScrollToTop />
              <About />
              <Footer />
            </>
          } />
          <Route path="/our-business" element={
            <>
              <Navigation />
              <ScrollToTop />
              <OurBusiness />
              <Footer />
            </>
          } />
          <Route path="/our-compliance" element={
            <>
              <Navigation />
              <ScrollToTop />
              <OurCompliance />
              <Footer />
            </>
          } />
          <Route path="/careers" element={
            <>
              <Navigation />
              <ScrollToTop />
              <Careers />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Navigation />
              <ScrollToTop />
              <Contact />
              <Footer />
            </>
          } />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster position="top-right" />
      </div>
    </Router>
  );
}